import { Link } from "react-router-dom";
import { Briefcase, ArrowLeft } from "lucide-react";

export default function ComingSoon() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-4">
      <div className="text-center max-w-sm">
        <div className="w-16 h-16 rounded-2xl bg-brand-tint grid place-items-center mx-auto mb-5">
          <Briefcase className="w-8 h-8 text-brand" />
        </div>
        <p className="font-display font-black text-2xl tracking-tighter mb-2">EarnMate freelance</p>
        <p className="text-sm text-muted-foreground mb-6">
          We're building this out. Freelance projects and hiring are coming soon — stay tuned.
        </p>
        <Link to="/events" className="btn-primary inline-flex items-center gap-2">
          <ArrowLeft className="w-4 h-4" /> Go to Events
        </Link>
      </div>
    </div>
  );
}